export const prettyPrint = (arg: any, replacer?: Parameters<typeof JSON.stringify>[1]) => JSON.stringify(arg, replacer, 2);
